export default __webpack_public_path__ + "static/media/qrStep2Icon.3a3c556b.png";